function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 164.444,
    y: 423.343,
    style: {
      fill: "#A9C4C4"
    },
    width: 183.113,
    height: 80.573
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#A9C4C4"
    },
    points: "347.556,88.66 347.556,8.084 164.444,8.084 164.444,88.66  "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.452,
    y: 13.204,
    style: {
      fill: "#231F20"
    },
    width: 17.246,
    height: 497.88
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#547475"
    },
    points: "300.791,88.66 151.247,88.66 119.212,142.68 119.212,158.661 119.212,353.339  119.212,369.32 151.247,423.34 360.751,423.34 392.788,369.32 392.788,353.339 392.788,158.661 392.788,142.68 360.751,88.66  325.225,88.66 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53CAF9"
    },
    d: "M208.81,355.505h112.812h8.844h5.169h8.844c8.375,0,15.164-6.788,15.164-15.162V171.657 c0-8.372-6.79-15.162-15.164-15.162h-8.844h-5.169h-8.844H190.378h-8.846h-5.166h-8.846c-8.376,0-15.162,6.79-15.162,15.162v168.686 c0,8.375,6.785,15.162,15.162,15.162h8.846h1.933h5.72"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F74848"
    },
    d: "M241.973,232.366c0,5.886-4.773,10.661-10.661,10.661h-33.44c-5.889,0-10.664-4.775-10.664-10.661 v-30.208c0-5.886,4.775-10.661,10.664-10.661h33.44c5.889,0,10.661,4.775,10.661,10.661V232.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.973,309.843c0,5.887-4.773,10.661-10.661,10.661h-33.44c-5.889,0-10.664-4.774-10.664-10.661 v-30.208c0-5.887,4.775-10.661,10.664-10.661h33.44c5.889,0,10.661,4.774,10.661,10.661V309.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFD760"
    },
    d: "M325.51,232.366c0,5.886-4.773,10.661-10.661,10.661h-33.44c-5.889,0-10.664-4.775-10.664-10.661 v-30.208c0-5.886,4.775-10.661,10.664-10.661h33.44c5.889,0,10.661,4.775,10.661,10.661V232.366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AAE6F9"
    },
    d: "M325.51,309.843c0,5.887-4.773,10.661-10.661,10.661h-33.44c-5.889,0-10.664-4.774-10.664-10.661 v-30.208c0-5.887,4.775-10.661,10.664-10.661h33.44c5.889,0,10.661,4.774,10.661,10.661V309.843z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#231F20"
    },
    points: "179.55,415.828 175.05,415.828 144.452,364.234 144.452,348.969 144.452,163.03  144.452,147.766 175.05,96.172 179.55,96.172 179.55,88.66 151.247,88.66 119.212,142.68 119.212,158.661 119.212,353.339  119.212,369.32 151.247,423.34 179.55,423.34  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M399.742,138.556l-32.038-54.02c-1.457-2.454-4.099-3.96-6.953-3.96h-5.109V8.084 c0-4.466-3.618-8.084-8.084-8.084H164.444c-4.466,0-8.084,3.618-8.084,8.084v72.492h-5.111c-2.854,0-5.498,1.505-6.953,3.961 l-32.036,54.02c-0.741,1.247-1.131,2.672-1.131,4.123v226.64c0,1.452,0.39,2.876,1.131,4.123l32.036,54.02 c1.456,2.455,4.099,3.961,6.953,3.961h5.111v72.492c0,4.466,3.618,8.084,8.084,8.084h183.113c4.466,0,8.084-3.618,8.084-8.084 v-72.492h5.109c2.854,0,5.497-1.505,6.953-3.96l32.038-54.02c0.741-1.248,1.131-2.672,1.131-4.124V142.68 C400.872,141.228,400.482,139.804,399.742,138.556z M339.472,495.832H172.528v-64.407h166.944V495.832z M384.704,367.103 l-28.558,48.153h-8.59H164.444h-8.592l-28.556-48.153V144.897l28.556-48.153h144.939c4.466,0,8.084-3.618,8.084-8.084 c0-4.466-3.618-8.084-8.084-8.084H172.528V16.168h166.944v64.407h-14.249c-4.466,0-8.084,3.618-8.084,8.084 c0,4.466,3.618,8.084,8.084,8.084h30.923l28.558,48.153L384.704,367.103L384.704,367.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M167.519,148.411c-12.818,0-23.246,10.429-23.246,23.246v168.686 c0,12.818,10.429,23.246,23.246,23.246h16.499c4.466,0,8.084-3.618,8.084-8.084s-3.618-8.084-8.084-8.084h-16.499 c-3.903,0-7.077-3.174-7.077-7.077V171.657c0-3.903,3.174-7.077,7.077-7.077h176.96c3.904,0,7.08,3.174,7.08,7.077v168.686 c0,3.903-3.176,7.077-7.08,7.077H208.81c-4.466,0-8.084,3.618-8.084,8.084s3.618,8.084,8.084,8.084h135.669 c12.819,0,23.248-10.429,23.248-23.246V171.657c0-12.818-10.43-23.246-23.248-23.246H167.519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M284.431,379.888h-56.861c-4.466,0-8.084,3.618-8.084,8.084s3.618,8.084,8.084,8.084h56.861 c4.466,0,8.084-3.618,8.084-8.084S288.896,379.888,284.431,379.888z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M197.872,251.112h33.44c10.336,0,18.746-8.41,18.746-18.746v-30.208 c0-10.336-8.41-18.746-18.746-18.746h-33.44c-10.337,0-18.748,8.41-18.748,18.746v30.208 C179.126,242.702,187.535,251.112,197.872,251.112z M195.294,202.158c0-1.421,1.157-2.577,2.579-2.577h33.44 c1.421,0,2.577,1.156,2.577,2.577v30.208c0,1.421-1.156,2.577-2.577,2.577h-33.44c-1.422,0-2.579-1.156-2.579-2.577V202.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M179.126,309.843c0,10.336,8.411,18.746,18.748,18.746h33.44c10.336,0,18.746-8.41,18.746-18.746 v-30.208c0-10.336-8.41-18.746-18.746-18.746h-33.44c-10.337,0-18.748,8.41-18.748,18.746V309.843z M195.294,279.635 c0-1.421,1.157-2.577,2.579-2.577h33.44c1.421,0,2.577,1.156,2.577,2.577v30.208c0,1.421-1.156,2.577-2.577,2.577h-33.44 c-1.422,0-2.579-1.156-2.579-2.577V279.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M281.409,251.112h33.44c10.336,0,18.746-8.41,18.746-18.746v-30.208 c0-10.336-8.41-18.746-18.746-18.746h-33.44c-10.337,0-18.748,8.41-18.748,18.746v30.208 C262.662,242.702,271.072,251.112,281.409,251.112z M278.831,202.158c0-1.421,1.157-2.577,2.579-2.577h33.44 c1.421,0,2.577,1.156,2.577,2.577v30.208c0,1.421-1.155,2.577-2.577,2.577h-33.44c-1.422,0-2.579-1.156-2.579-2.577V202.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M262.662,309.843c0,10.336,8.411,18.746,18.748,18.746h33.44c10.336,0,18.746-8.41,18.746-18.746 v-30.208c0-10.336-8.41-18.746-18.746-18.746h-33.44c-10.337,0-18.748,8.41-18.748,18.746V309.843z M278.831,279.635 c0-1.421,1.157-2.577,2.579-2.577h33.44c1.421,0,2.577,1.156,2.577,2.577v30.208c0,1.421-1.155,2.577-2.577,2.577h-33.44 c-1.422,0-2.579-1.156-2.579-2.577V279.635z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartWatch);
export default __webpack_public_path__ + "static/media/smart-watch.916bc7c5df0b22281449b8d8159762ac.svg";
export { ForwardRef as ReactComponent };